//Models
PJQ.models.changeRequests.ChangeRequest = PJQ.models.BaseModel.extend({
    defaults: {
        isAPIv2: true
    },
    idAttribute: 'id',
    endpoint: function () {
        let arr = [];
        if (this.isNew()) {
            arr.push({
                endpoint: 'projects',
                value: this.get('projectId')
            });
        }
        arr.push({
            endpoint: 'changerequests',
            value: this.id
        });
        return PJQ.helpers.urlHelpers.generateEndpoint(arr);
    },
    parse: function (model) {
        if (!model)
            return model;

        if (model.primeContract) {
            this.primeContract = model.primeContract;
        }

        this.lineItems = new PJQ.collections.changeRequests.ChangeRequestLineItems(model.lineItems);
        this.attachments = new PJQ.collections.changeRequests.ChangeRequestAttachments(model.attachments);
        this.rfq = new PJQ.collections.rfq.RFQs(model.rfq, {
            projectId: model.projectId,
            changeRequestId: model.id
        });

        this.markupItems = new PJQ.financialMarkups.collections.FinancialMarkups(model ? model.markupItems : null);

        if (model && model.client) {
            if (model.client instanceof PJQ.models.BaseModel) {
                this.client = model.client;
            } else {
                this.client = new PJQ.models.contacts.Contact(model.client);
            }
        } else {
            this.client = null;
        }

        return model;
    },
    fetchRFQs(callback) {
        return new Promise((resolve, reject) => {
            if (this.rfq != null && this.rfq.isFetched) {
                if (typeof callback === 'function') {
                    callback(this.rfq);
                }
                resolve(this.rfq);
                return;
            }

            this.rfq = new PJQ.collections.rfq.RFQs([], {
                projectId: this.get('projectId'),
                changeRequestId: this.id
            });
            this.rfq.fetch({
                success: () => {
                    if (typeof callback === 'function') {
                        callback(this.rfq);
                    }
                    resolve(this.rfq);
                },
                error: () => {
                    if (typeof callback === 'function') {
                        callback(this.rfq);
                    }
                    reject(new Error("Failed to fetch change request rfqs"));
                }
            })
        });
    },
    beforeSave: function () {
        let newMarkupLines = this.lineItems.filter(function (lineItem) {
            return lineItem.markup && lineItem.isNew();
        });
        this.lineItems.remove(newMarkupLines);

        this.set({
            lineItems: this.lineItems.toJSON(),
            attachments: this.attachments.toJSON(),
            markupItems: this.markupItems.toJSON()
        });
    },
    syncERP: function (callback) {
        new PJQ.ajax.Request({
            endpoint: this.endpoint() + '/syncerp',
            isAPIv2: true,
        }).post().done(_.bind(function (res) {
            if (res && _.size(res.externalId) > 0) {
                this.set('externalObject', res);
            }
            if (typeof callback === 'function') {
                callback(res);
            }
        }, this)).fail(_.bind(function (xhr, err, result) {
            if (typeof callback === 'function') {
                callback(null);
            }
        }, this));
    },
    unlinkERP: function (callback) {
        new PJQ.ajax.Request({
            endpoint: this.endpoint() + '/unlinkerp',
            isAPIv2: true,
        }).post().done(_.bind(function () {
            this.set('externalObject', null);
            if (typeof callback === 'function') {
                callback(true);
            }
        }, this)).fail(_.bind(function (xhr) {
            if (typeof callback === 'function') {
                let err;
                if (xhr.responseJSON != null) {
                    err = xhr.responseJSON.type;
                } else {
                    err = null;
                }
                callback(false, err);
            }
        }, this));
    },
    makeERPUrl: function (integration) {
        let externalId = this.externalId();
        if (_.size(externalId) === 0) {
            return '';
        }

        switch (integration.get('name')) {
            case PJQ.constants.integrations.providers.QBO.name:
                // TODO: QBO Integration URL
                return 'https://app.sandbox.qbo.intuit.com/app/purchaseorder?txnId=' + externalId;
            default:
                return '';
        }
    },
    share: function (data, callback) {
        new PJQ.ajax.Request({
            endpoint: this.endpoint() + '/email',
            isAPIv2: true,
            data: {
                subject: data != null ? data.subject : null,
                body: data != null ? data.body : null,
                toEmails: data != null ? data.toEmails : null,
                ccEmails: data != null ? data.ccEmails : null,
            }
        }).post().done(_.bind(function (response) {
            callback();
        }, this)).fail(_.bind(function (xhr, err, result) {
            //todo: error
        }, this));
    },
    getSubTotal: function (markups, costOnly) {
        if (costOnly) {
            return this.get('amount') + this.get('markupAmount');
        }

        return this.get('revenue') + this.get('markupAmount');
    },
    getGrandTotal: function () {
        let costsOnly = this.get('scope') === PJQ.constants.changeRequests.scope.INTERNAL;
        return this.getSubTotal(null, costsOnly) + this.get('taxAmount');
    },
    canAttachLineItemCost: function (lineItem) {
        if (this.get('statusId') === PJQ.constants.changeRequests.changeRequestStatus.VOID
            || this.get('statusId') === PJQ.constants.changeRequests.changeRequestStatus.REJECTED) {
            return false;
        }

        return !(lineItem.get('costLineItemId') > 0);
    },
    canAttachLineItemRevenue: function (lineItem) {
        if (this.get('statusId') !== PJQ.constants.changeRequests.changeRequestStatus.APPROVED
            || this.get('scope') === PJQ.constants.changeRequests.scope.INTERNAL) {
            return false;
        }

        return !(lineItem.get('revenueLineItemId') > 0);
    },
    canSendRFQ: function () {
        return this.get('statusId') === PJQ.constants.changeRequests.changeRequestStatus.APPROVED
            || this.get('statusId') === PJQ.constants.changeRequests.changeRequestStatus.REJECTED
            || this.get('statusId') === PJQ.constants.changeRequests.changeRequestStatus.VOID;
    }
});

PJQ.models.changeRequests.ChangeRequestLineItem = PJQ.models.budget.BaseLineItem.extend({
    defaults: {
        isAPIv2: true
    },
    idAttribute: 'id'
});

PJQ.models.changeRequests.ChangeRequestAttachment = PJQ.models.files.File.extend({
    defaults: {
        isAPIv2: true
    },
    idAttribute: 'id'
});

PJQ.models.changeRequests.CustomField = PJQ.models.customFields.CustomField.extend({
    defaults: {
        isAPIv2: true
    },
    idAttribute: 'id',
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'changerequests'
            },
            {
                endpoint: 'customfields',
                value: this.get('id')
            }
        ]);
    }
});

PJQ.models.changeRequests.CustomFieldChoice = PJQ.models.BaseModel.extend({
    defaults: {
        isAPIv2: true
    },
    idAttribute: 'id',
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'changerequests'
            },
            {
                endpoint: 'customfields',
                value: this.get('customFieldId')
            },
            {
                endpoint: 'choices',
                value: this.get('id')
            }
        ]);
    }
});

PJQ.models.changeRequests.Settings = PJQ.models.BaseModel.extend({
    defaults: {
        isAPIv2: true
    },
    idAttribute: 'settingId',
    endpoint: function () {
        if (this.options.projectId > 0) {
            return PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'projects',
                    value: this.options.projectId
                },
                {
                    endpoint: 'changerequests'
                },
                {
                    endpoint: 'settings'
                }
            ]);
        }

        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'changerequests'
            },
            {
                endpoint: 'settings'
            }
        ]);
    },
    parseNumberFormat: function (numberFormat, project, additionalData) {
        let result = '';

        _.each(numberFormat, _.bind(function (token) {
            if (token.isText)
                result += token.label;
            else if (token.token === 'today')
                result += this.parseDateFormatToken(new Date(), token.dateFormatId);
            else if (token.token === 'project.projectId')
                result += project.get('projectId').toString();
            else if (token.token === 'project.startDate')
                result += this.parseDateFormatToken(PJQ.helpers.dateHelpers.parseDateString(project.get('startDate'), false), token.dateFormatId);
            else if (token.token === 'counter')
                result += additionalData.counter.toString().padStart(4, '0');
            else if (token.token.startsWith('fieldValue')) {
                let fieldNumber = parseInt(token.token.substr(10));
                _.each(PJQ.app.session.project.customFields.models, _.bind(function (customField) {
                    if (customField.get('fieldNumber') === fieldNumber) {
                        _.each(PJQ.app.session.project.get('customFields'), _.bind(function (fieldValue) {
                            if (fieldValue.fieldNumber === fieldNumber) {
                                switch (customField.get('fieldType')) {
                                    case PJQ.constants.customFields.fieldTypes.TEXT:
                                    case PJQ.constants.customFields.fieldTypes.INT:
                                        result += fieldValue.value.toString();
                                        break;
                                    case PJQ.constants.customFields.fieldTypes.CHOICE:
                                        _.each(customField.get('choices'), _.bind(function (choice) {
                                            if (choice.id === fieldValue.value)
                                                result += choice.choiceName;
                                        }, this));
                                        break;
                                    case PJQ.constants.customFields.fieldTypes.DATE:
                                        result += this.parseDateFormatToken(PJQ.helpers.dateHelpers.parseDateString(fieldValue.value, false), token.dateFormatId);
                                        break;
                                    case PJQ.constants.customFields.fieldTypes.DATETIME:
                                        result += this.parseDateFormatToken(PJQ.helpers.dateHelpers.parseDateString(fieldValue.value, true), token.dateFormatId);
                                        break;
                                }
                            }
                        }, this));
                    }
                }, this));
            }
        }, this));

        return result.replaceAll(' ', '');
    },
    parseDateFormatToken: function (input, dateFormatId) {
        let result = null;

        switch (dateFormatId) {
            case PJQ.constants.commitments.commitmentNumberTokenDateFormat.DD:
                result = input.getDate().toString().padStart(2, '0');
                break;
            case PJQ.constants.commitments.commitmentNumberTokenDateFormat.MM:
                result = (input.getMonth() + 1).toString().padStart(2, '0');
                break;
            case PJQ.constants.commitments.commitmentNumberTokenDateFormat.YY:
                result = input.getFullYear().toString().substr(2);
                break;
            case PJQ.constants.commitments.commitmentNumberTokenDateFormat.YYYY:
                result = input.getFullYear().toString();
                break;
            case PJQ.constants.commitments.commitmentNumberTokenDateFormat.MMDDYYYY:
                result = PJQ.helpers.dateHelpers.getDateString(input, PJQ.helpers.dateHelpers.dateFormats.URL_DATE, false).replaceAll('-', '');
                break;
        }

        return result;
    }
});

PJQ.models.changeRequests.ChangeRequestUserSettings = PJQ.models.BaseModel.extend({
    defaults: {
        isAPIv2: true
    },
    idAttribute: 'settingId',
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'changerequests'
            },
            {
                endpoint: 'settings'
            },
            {
                endpoint: 'user'
            }
        ]);
    },
    getSettings: function (view) {
        return _.find(this.attributes.viewSettings, _.bind(function (setting) {
            return setting.view === view;
        }, this));
    }
});

//Collections
PJQ.collections.changeRequests.ChangeRequests = PJQ.collections.BaseCollection.extend({
    defaults: {
        isAPIv2: true
    },
    model: PJQ.models.changeRequests.ChangeRequest,
    endpoint: function () {
        let params = [];
        if (this.options.groupId && this.options.costTypeId) {
            params.push({
                parameter: 'groupId',
                value: this.options.groupId
            }, {
                parameter: 'costTypeId',
                value: this.options.costTypeId
            });
        }
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'projects',
                value: this.options.projectId
            },
            {
                endpoint: 'changerequests'
            }
        ], params);
    },
    getTotalAmountsByStatus: function () {
        let result = {};
        _.each(PJQ.constants.changeRequests.changeRequestStatusBuckets, function (bucket) {
            let total = 0;
            _.each(this.models, function (changeRequest) {
                if (bucket.statuses.indexOf(changeRequest.get('statusId')) !== -1) {
                    total += changeRequest.get('amount');
                }
            });
            result[bucket.name] = total;
        }, this);
        return result;
    }
});

PJQ.collections.changeRequests.ChangeRequestLineItems = PJQ.collections.BaseCollection.extend({
    defaults: {
        isAPIv2: true
    },
    model: PJQ.models.changeRequests.ChangeRequestLineItem,
    endpoint: function () {
        let params = [];
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'changerequests',
                value: this.options.changeRequestId
            },
            {
                endpoint: 'lineitems'
            }
        ], params);
    }
});

PJQ.collections.changeRequests.ChangeRequestAttachments = PJQ.collections.files.Files.extend({
    defaults: {
        isAPIv2: true
    },
    model: PJQ.models.changeRequests.ChangeRequestAttachment,
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'changerequests',
                value: this.options.changeRequestId
            },
            {
                endpoint: 'attachments'
            }
        ]);
    }
});

PJQ.collections.changeRequests.CustomFields = PJQ.collections.BaseCollection.extend({
    defaults: {
        isAPIv2: true
    },
    model: PJQ.models.changeRequests.CustomField,
    endpoint: function () {
        let params = [];
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'changerequests'
            },
            {
                endpoint: 'customfields'
            }
        ], params);
    }
});

PJQ.collections.changeRequests.CustomFieldChoices = PJQ.collections.BaseCollection.extend({
    defaults: {
        isAPIv2: true
    },
    model: PJQ.models.changeRequests.CustomFieldChoice
});